/* eslint-disable*/

import { Alert, Button, Grid, TextField, Typography } from '@mui/material'
import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import * as yup from 'yup'
import { loginWithDematOTP, resendOtp, getUserDetails } from '../utils/AuthUtil'
import LoadingButton from '@mui/lab/LoadingButton'
import ReactGA4 from 'react-ga4'
import PostHogTracker from '../utils/PostHogTracker'
import { InputOTP, InputOTPGroup, InputOTPSlot } from '../Components/ui/input-otp'
import { REGEXP_ONLY_DIGITS } from 'input-otp'
import LoginLock from '../Components/Auth/LoginLock'
import CreateSharpIcon from '@mui/icons-material/CreateSharp'
import CachedSharpIcon from '@mui/icons-material/CachedSharp'

const LoginWithOTP = () => {
  const [errorMessage, setErrorMessage] = useState(null)
  const navigate = useNavigate()
  const location = useLocation()

  const [userId, setUserId] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [loading, setLoading] = useState(false)
  const [counter, setCounter] = useState(45)
  const [firstName, setFirstName] = useState('')
  const [otp, setOtp] = useState(null)
  const [error, setError] = useState(null)
  const [isLoginSuccessfull, setIsLoginSuccessfull] = useState(false)

  useEffect(() => {
    setUserId(location.state?.uid)
    setPhoneNumber(location.state?.phoneNumber)
    setFirstName(location.state?.firstName)
  }, [])

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000)
    return () => clearInterval(timer)
  }, [counter])

  const handleChange = (value) => {
    setOtp(value)
  }

  const resendOTP = async () => {
    setOtp(null)
    setErrorMessage(null)
    try {
      const payload = {
        uid: userId,
        requestCode: '115',
      }

      const resendOtpResponse = await resendOtp(payload)
      setLoading(false)
      if (resendOtpResponse.isError) {
        if (resendOtpResponse.code === 'Unauthorized') {
          setErrorMessage(resendOtpResponse.message.message)
        } else {
          setErrorMessage('Unable to process your request.Please try again')
        }
        return
      }
      setCounter(45)
    } catch (e) {
      setLoading(false)
      return
    }
  }

  const otpLogin = async (event) => {
    event.preventDefault()

    try {
      setErrorMessage(null)
      const payload = {
        uid: userId,
        otp: otp,
        phoneNumber,
      }
      const response = await loginWithDematOTP(payload)
      ReactGA4.event({
        category: 'Login',
        action: 'Login OTP Entered',
      })
      PostHogTracker.otpEntered('login')
      setLoading(false)

      if (response.code === 'Success') {
        setIsLoginSuccessfull(true)
      }

      if (response.isError) {
        if (response.code === 'Unauthorized') {
          setErrorMessage('You entered an incorrect OTP!')
        } else {
          setErrorMessage('Unable to process your request.Please try again')
        }
        ReactGA4.event({
          category: 'Login',
          action: 'OTP Failure',
        })
        PostHogTracker.otpFailure('login', 'invalid_otp')
        return
      }
      localStorage.setItem('uid', userId)
      const userDetails = getUserDetails()
      // console.log('GA event', userDetails)
      // Send logged in user details to GA4 and PostHog
      ReactGA4.event({
        category: 'Login',
        action: 'Login Complete',
        value: userDetails.email,
      })
      ReactGA4.set({ userId: userDetails.email })

      // Use enhanced PostHog identification with super properties
      // Using phone number as distinct ID (works for both KYC and non-KYC users)
      PostHogTracker.loginCompleted(phoneNumber, userDetails, 'otp')
      if (window.utmData && window.utmData['$marketing_title']) {
        if (window.utmData['$marketing_title'] === 'Insurance') {
          navigate('/dashboard/insurance')
        } else {
          let navState = null
          if (window.utmData.navigation_state) {
            navState = JSON.parse(window.utmData.navigation_state)
            // console.log(navState)
          }
          if (window.utmData.site_url) {
            setIsLoginSuccessfull(false)
            navigate(window.utmData.site_url, { state: navState })
          } else {
            setTimeout(() => {
              setIsLoginSuccessfull(false)
              navigate('/dashboard', {
                state: { login: true, firstTimeUser: false, hasSeenVideo: true },
              })
            }, 1000)
          }
        }
      } else {
        setTimeout(() => {
          setIsLoginSuccessfull(false)
          navigate('/dashboard', {
            state: { login: true, firstTimeUser: false, hasSeenVideo: true },
          })
        }, 1000)
      }
    } catch (e) {
      setIsLoginSuccessfull(false)
      setLoading(false)
      return
    }
  }

  if (isLoginSuccessfull) {
    return <LoginLock firstName={firstName} />
  }

  return (
    <div className='mx-auto flex w-full max-w-[360px] min-w-0 flex-col items-center justify-center lg:max-w-[432px]'>
      <div className='mb-6 flex flex-col gap-y-1'>
        <h1 className='text-center font-IBM text-[28px] font-bold leading-9 text-white lg:text-[36px] lg:leading-10 lg:text-black-950 dark:lg:text-[var(--fb-text)]'>
          Login
        </h1>
        <p className='flex items-center justify-center gap-x-1 text-center font-IBM text-sm font-medium leading-5 text-black-300 lg:text-black-400 dark:lg:text-black-300'>
          <svg
            width='14'
            height='14'
            viewBox='0 0 12 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M1.99996 14.614C1.63329 14.614 1.3194 14.4835 1.05829 14.2223C0.797182 13.9612 0.666626 13.6473 0.666626 13.2807V6.61401C0.666626 6.24735 0.797182 5.93346 1.05829 5.67235C1.3194 5.41124 1.63329 5.28068 1.99996 5.28068H2.66663V3.94735C2.66663 3.02512 2.99163 2.23901 3.64163 1.58901C4.29163 0.939014 5.07774 0.614014 5.99996 0.614014C6.92218 0.614014 7.70829 0.939014 8.35829 1.58901C9.00829 2.23901 9.33329 3.02512 9.33329 3.94735V5.28068H9.99996C10.3666 5.28068 10.6805 5.41124 10.9416 5.67235C11.2027 5.93346 11.3333 6.24735 11.3333 6.61401V13.2807C11.3333 13.6473 11.2027 13.9612 10.9416 14.2223C10.6805 14.4835 10.3666 14.614 9.99996 14.614H1.99996ZM5.99996 11.2807C6.36663 11.2807 6.68052 11.1501 6.94163 10.889C7.20274 10.6279 7.33329 10.314 7.33329 9.94735C7.33329 9.58068 7.20274 9.26679 6.94163 9.00568C6.68052 8.74457 6.36663 8.61401 5.99996 8.61401C5.63329 8.61401 5.3194 8.74457 5.05829 9.00568C4.79718 9.26679 4.66663 9.58068 4.66663 9.94735C4.66663 10.314 4.79718 10.6279 5.05829 10.889C5.3194 11.1501 5.63329 11.2807 5.99996 11.2807ZM3.99996 5.28068H7.99996V3.94735C7.99996 3.39179 7.80552 2.91957 7.41663 2.53068C7.02774 2.14179 6.55551 1.94735 5.99996 1.94735C5.4444 1.94735 4.97218 2.14179 4.58329 2.53068C4.1944 2.91957 3.99996 3.39179 3.99996 3.94735V5.28068Z'
              fill='currentColor'
            />
          </svg>
          Two-factor authentication enabled
        </p>
      </div>
      <div className='flex flex-col justify-center items-center'>
        <p className='flex flex-row whitespace-nowrap font-IBM text-sm font-medium leading-5 text-black-300 lg:text-black-400 dark:lg:text-black-300'>
          Enter the OTP sent to
        </p>
        <div
          className='flex justify-center items-center gap-x-1 border-primary-500 border-dashed w-min border-b-[2px] mb-6 cursor-pointer'
          onClick={() => navigate('/login')}
        >
          <p className='whitespace-nowrap font-IBM font-semibold text-primary-500 text-decoration-none'>
            {phoneNumber}
          </p>
          <CreateSharpIcon
            className='cursor-pointer text-primary-500 text-[16px]'
            sx={{ fontSize: '16px' }}
          />
        </div>
      </div>
      <div className='mb-12'>
        {counter == 0 ? (
          <button
            onClick={() => {
              PostHogTracker.buttonClicked('Resend OTP', {
                action: 'Resend OTP',
                page_name: 'Demat Login',
              })
              setLoading(true)
              resendOTP()
            }}
            className='flex cursor-pointer flex-row items-center justify-center gap-x-1 whitespace-nowrap border-b-[2px] border-dashed border-primary-500 font-IBM text-sm font-semibold leading-5 text-primary-500'
          >
            <CachedSharpIcon className='text-primary-500' sx={{ fontSize: '20px' }} />
            Resend OTP
          </button>
        ) : (
          <div className='flex flex-row justify-center items-center gap-x-1 border-b-[2px] border-transparent'>
            <CachedSharpIcon className=' text-black-300 lg:text-black-400' sx={{ fontSize: '20px' }} />
            <p className='flex flex-row whitespace-nowrap font-IBM text-sm font-medium leading-5 text-black-300 lg:text-black-400 dark:lg:text-black-300'>
              {' '}
              Resend OTP in <p className='font-semibold text-white lg:text-black-500 dark:lg:text-[var(--fb-text)]'>&nbsp;{counter} sec</p>
            </p>
          </div>
        )}
      </div>

      <Grid item xs={12}>
        <form onSubmit={otpLogin}>
          <InputOTP
            maxLength={6}
            pattern={REGEXP_ONLY_DIGITS}
            value={otp}
            onChange={(value) => handleChange(value)}
            containerClassName='w-full'
          >
            <InputOTPGroup className='w-full justify-between'>
              {[0, 1, 2, 3, 4, 5].map((index) => (
                <InputOTPSlot
                  key={index}
                  index={index}
                  className={`${
                    errorMessage && 'border-error-600 text-error-600 font-medium'
                  } h-11 w-9 rounded-xl border-[#3a3d56] bg-transparent px-0 text-base leading-6 text-white min-[360px]:h-12 min-[360px]:w-11 lg:border-[#D3DBEC] lg:text-black-950 dark:lg:border-[var(--fb-border-strong)] dark:lg:text-[var(--fb-text)]`}
                />
              ))}
            </InputOTPGroup>
          </InputOTP>

          <div className='text-center text-xs text-error-600 font-medium mt-2'>
            {errorMessage && <>{errorMessage}</>}
          </div>

          <LoadingButton
            variant='contained'
            loading={loading}
            sx={{
              mt: '24px',
              py: '12px',
              px: '24px',
              fontSize: '14px',
              lineHeight: '20px',
              fontWeight: '600',
              fontFamily: 'IBM Plex Sans',
              textTransform: 'none',
              borderRadius: '12px',
              boxShadow: '0 10px 24px rgba(40, 24, 255, 0.18)',
              '&:hover': {
                backgroundColor: '#2818ff',
                boxShadow: '0 10px 24px rgba(40, 24, 255, 0.18)',
              },
              '&:active': { backgroundColor: '#2818ff', boxShadow: 'none' },
              '&.Mui-disabled': {
                backgroundColor: '#97aaff',
                color: '#fff',
                opacity: 1,
              },
            }}
            fullWidth
            disabled={otp === null || otp.length != 6}
            onClick={(event) => {
              setLoading(true)
              otpLogin(event)
            }}
          >
            Verify OTP
          </LoadingButton>
        </form>
      </Grid>
      {/* <Grid item xs={12} sx={{ textAlign: 'center' }}>
        <Button
          sx={{
            textTransform: 'none',
          }}
          onClick={() => {
            navigate('/password', {
              state: {
                phoneNumber,
              },
            })
          }}
        >
          Back
        </Button>
      </Grid> */}
    </div>
  )
}

export default LoginWithOTP
